import {
    Component,
    Input,
    ViewChild,
    Output,
    EventEmitter,
} from "@angular/core";
import { SelectionModel } from "@angular/cdk/collections";
import {
    MatTableDataSource,
    MatTableModule,
    MatTable,
} from "@angular/material/table";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";

@Component({
    selector: "filter-list",
    standalone: true,
    imports: [
        MatTableModule,
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    templateUrl: "./filter-list.component.html",
    styleUrl: "./filter-list.component.scss",
})

export class FilterListComponent {
    @Output() filterEmit = new EventEmitter<any>();

    @Input({ required: true }) filterName: string;
    @Input({ required: true }) dataSource: MatTableDataSource<string>;

    selection = new SelectionModel<string>(true, []);
    columsWithSelect: string[];
    columnsToDisplay: string[] = ["Select All"];

    @ViewChild(MatTable) table!: MatTable<string>;

    ngOnInit() {
        this.columsWithSelect = ["select", ...this.columnsToDisplay];
        this.dataSource.filterPredicate = (data: string, filter: string) => {
            return (data as string).toLowerCase().includes(filter.toLowerCase());
        };
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            this.filterEmit.emit(this.selection.selected);
            return;
        }

        this.selection.select(...this.dataSource.data);
        this.filterEmit.emit(this.selection.selected);
    }

    onCheckboxChange(row: any): void {
        this.selection.toggle(row);
        this.filterEmit.emit(this.selection.selected);
    }

    checkboxLabel(row?: string): string {
        if (!row) {
            return `${this.isAllSelected() ? "deselect" : "select"} all`;
        }
        return `${this.selection.isSelected(row) ? "deselect" : "select"} ${row}`;
    }

    applySearchFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue;
    }
}
